// extracted by extract-css-chunks-webpack-plugin
module.exports = {"circularChart":"_36hqBZ","circleBg":"_1fyhFO","circle":"_2xt4xe"};